import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4979d63e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ml-s2" }

import Icon from '@/components/Icon.vue';

export default /*#__PURE__*/_defineComponent({
  props: {
    message: null,
    type: null,
    size: null,
    asPanel: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  message?: string;
  type: string;
  size?: string;
  asPanel?: boolean;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      __props.asPanel ? `panel-info-${__props.type} flex text-sm` : `inline-flex text-${__props.type}`
    , "align-items-baseline"])
  }, [
    _createVNode(Icon, {
      name: __props.type,
      size: __props.size || '16'
    }, null, 8, ["name", "size"]),
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(__props.message), 1)
      ])
    ])
  ], 2))
}
}

})